import { Component, h } from 'preact';
import Hammer from 'hammerjs';

export default class Song extends Component {
  state = {
    showLyrics: window.scrollY !== 0,
  };

  componentDidMount() {
    const { hasScrolled } = this.state;
    if (!hasScrolled) {
      window.addEventListener('scroll', this.handleFirstScroll);
    }
    // Hammerjs hack for element that has overflow set
    // https://github.com/hammerjs/hammer.js/issues/1065#issuecomment-310620039
    Hammer(this.base).on('swipe', () => {});
  }

  componentWillUnmount() {
    // Make sure to remove the DOM listener when the component is unmounted.
    window.removeEventListener('scroll', this.handleFirstScroll);
  }

  handleFirstScroll = () => {
    window.removeEventListener('scroll', this.handleFirstScroll);
    this.setState({
      showLyrics: true,
    });
  };

  render() {
    const {
      backgroundColor, color, credits, done, saving, title, verses,
    } = this.props;
    const { showLyrics } = this.state;
    const dynamicStyles = { backgroundColor, color };

    let classes = 'song';
    if (showLyrics) classes += ' song--scrolled';
    if (done) classes += ' song--done';
    if (saving) classes += ' song--saving';

    const versesMarkup = verses.map((verse) => (
      h('p', null, verse.map((line) => ([line, <br />])))
    ));

    return (
      <div className={classes} style={dynamicStyles}>
        <h1 className="song__title">{title}</h1>
        <div className="song__content">
          <small className="song__credits">
            {credits.lyrics && `Tekst: ${credits.lyrics}`}
            <br />
            {credits.melody && `Melodi: ${credits.melody}`}
          </small>
          <div className="song__lyrics">
            {versesMarkup}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/song.js